/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Grid,
  Row,
  Col,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import Toolbar from 'loracoms/Toolbar';
import SearchInput from 'loracoms/SearchInput';
import ShowIf from 'loracoms/ShowIf';
import Count from './Count';
import BillingCard from './BillingCard';
import SearchOverlay from './SearchOverlay';
import DeviceMapPanel from './DeviceMapPanel';
import GatewayMapPanel from './GatewayMapPanel';
import imgGateway from './images/gateway_lg.svg';
import imgApp from './images/application_lg.svg';
import imgDevice from './images/device_lg.svg';
import styles from './styles.scss';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  usage: React.PropTypes.object.isRequired,
  basic: React.PropTypes.object.isRequired,
  gotoApps: React.PropTypes.func.isRequired,
  gotoGateways: React.PropTypes.func.isRequired,
  plan: React.PropTypes.object.isRequired,
};

class Overview extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      usage: props.usage,
      basic: props.basic,
      plan: props.plan,
    };
    this.intlMsg = new IntlMsg(props.intl, 'overview');
  }

  componentWillReceiveProps(nextProps) {
    const { usage, basic, plan } = nextProps;
    if (usage !== this.props.usage) {
      this.setState({ usage });
    }
    if (basic !== this.props.basic) {
      this.setState({ basic });
    }
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
  }

  renderToolbar() {
    const rightTools = [{
      type: 'search',
      searchInput: (
        <SearchInput
          placeholder={this.intlMsg.msg('search.placeholder')}
          value=""
          onFocus={() => this.setState({ showSearch: true })}
          onChange={() => {}}
        />
      ),
    }];
    return (
      <Toolbar
        brandTitle={<span className={styles.greeting}>{this.intlMsg.msg('greeting')}</span>}
        rightTools={rightTools}
      />
    );
  }

  render() {
    const { gotoApps, gotoGateways } = this.props;
    const {
      usage,
      basic: { data: basic = {} },
      showSearch = false,
    } = this.state;

    return (
      <div className={styles.wrapper}>
        <div className={styles.toolbar}>
          {this.renderToolbar()}
        </div>
        <Grid fluid>
          <Row>
            <Col md={3} className="collapse-left">
              <BillingCard />
            </Col>
            <Col md={3} className="collapse-both">
              <Count
                key={1}
                icon={imgGateway}
                name={this.intlMsg.msg('gateway')}
                value={usage.gateways}
                total={basic.lrgatewaynum}
                color="success"
                handleClick={gotoGateways}
              />
            </Col>
            <Col md={3} className="collapse-both">
              <Count
                icon={imgApp}
                name={this.intlMsg.msg('application')}
                value={usage.apps}
                total={basic.lrappnum}
                color="info"
                handleClick={gotoApps}
              />
            </Col>
            <Col md={3} className="collapse-both">
              <Count
                icon={imgDevice}
                name={this.intlMsg.msg('device')}
                value={usage.nodes}
                total={basic.lrnodenum}
                color="warning"
                handleClick={gotoApps}
              />
            </Col>
          </Row>
          <Row>
            {/* <Col md={6} className="collapse-both">
              <DeviceMapPanel />
            </Col>
            <Col md={6} className="collapse-both">
              <GatewayMapPanel />
            </Col> */}
          </Row>
        </Grid>
        <ShowIf if={showSearch} key="overlay">
          <SearchOverlay onHide={() => this.setState({ showSearch: false })} />
        </ShowIf>
      </div>
    );
  }
}

Overview.propTypes = propTypes;

const mapStateToProps = state => ({
  usage: state.usage,
  basic: state.org.basic,
  plan: state.billing.plan,
});

const mapDispatchToProps = dispatch => ({
  gotoApps: () => dispatch(push('/application')),
  gotoGateways: () => dispatch(push('/gateway')),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Overview));




// WEBPACK FOOTER //
// ./src/containers/Overview/index.jsx